import React from "react";
import PropTypes from 'prop-types';
import './Item.css';
import { Link } from "react-router-dom";

const Item = (props) => {
    // This function is great UX, we'll keep it.
    const handleImageClick = () => {
        window.scrollTo(0, 0);
    };

    return (
        // Changed to <article> for better semantics
        <article className="item-card">
            <Link to={`/product/${props.id}`} className="item-card__image-link" onClick={handleImageClick}>
                <img src={props.image} alt={props.name} />
            </Link>
            <div className="item-card__info">
                {/* Changed to an <h3> for better heading structure */}
                <h3 className="item-card__name">{props.name}</h3>
                <div className="item-card__prices">
                    <div className="item-card__price--new">
                        R{props.new_price}
                    </div>
                    <div className="item-card__price--old">
                        R{props.old_price}
                    </div>
                </div>
            </div>
        </article>
    );
}

// PropTypes are excellent practice! We're keeping them.
Item.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    new_price: PropTypes.number.isRequired,
    old_price: PropTypes.number.isRequired,
};

export default Item;